import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'name': 'String',
	'lunch_option_guid': 'String',
	'transport_option_guid': 'String',
	'language_guid': 'String',
	'response_employee': 'String',
	'confidant': 'String',
	'team_guid': 'String',
	'show_calendar': 'String',
	'show_phonenumber': 'String',
	'show_favourite': 'String',
	'vacation_mode_active': 'String',
	'visible_for_employees': 'String',
	
	'jobtitle_guid': 'String',
	'department_guid': 'String',
	'phonenumber': 'String',
	'landline_phonenumber': 'String',
	'license_plate': 'String',
	'transport_kind': 'String',
	'address_postal_code': 'String',
	'access_card_id': 'String',
};

export default gql(`
	mutation employee( ${ HelperGraphql.createFields( fields ) } ) {
	    employee( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        name
	        
	        jobtitle {
	            name
	        }
	        
	        department {
	            name
	        }
	    }
	}
`);

